module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.detailModal) ? _c('div', {
    staticClass: "modal__wrap--bg cmp-modal",
    class: {
      'is-active': _vm.detailModal
    },
    attrs: {
      "id": "detail-modal-template"
    }
  }, [_c('div', {
    staticClass: "modal-wrap-container modal-wd1020"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.getModalTitle()))])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body-container ht-full"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.modalState === 'resume'),
      expression: "modalState === 'resume'"
    }]
  }, [_c('div', {
    staticClass: "progress-section mypage-resumeform mt-40"
  }, [_c('div', {
    staticClass: "progress-data"
  }, [_c('div', {
    staticClass: "progress-text"
  }, [_vm._v("\n            완성도\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "progress-bar-container"
  }, [_c('div', {
    staticClass: "progress-bar",
    style: (_vm.getProgressWidth(_vm.resume.completionRate))
  })]), _vm._v(" "), _c('div', {
    staticClass: "percentage"
  }, [_vm._v(_vm._s(Math.round(_vm.resume.completionRate * 100)) + "%")])]), _vm._v(" "), _c('div', {
    staticClass: "progress-subtext"
  }, [_vm._v("(높은 이력서 완성도는 더 많은 맞춤형 일자리 추천을 받으실 수 있습니다.)")])]), _vm._v(" "), _c('div', {
    staticClass: "mypage-scroll-type tab-container-full full mt-40"
  }, [_c('div', {
    staticClass: "tab-head"
  }, [_c('div', {
    staticClass: "tab-menu-wrap scroll-tab"
  }, [_c('button', {
    staticClass: "tab-menu",
    class: {
      'is-active': _vm.selectedTab === 'basic'
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.changeTab('basic')
      }
    }
  }, [_vm._v("\n              기본정보\n            ")]), _vm._v(" "), _c('button', {
    staticClass: "tab-menu",
    class: {
      'is-active': _vm.selectedTab === 'schools'
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.changeTab('schools')
      }
    }
  }, [_vm._v("\n              학력사항\n            ")]), _vm._v(" "), _c('button', {
    staticClass: "tab-menu",
    class: {
      'is-active': _vm.selectedTab === 'careers'
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.changeTab('careers')
      }
    }
  }, [_vm._v("\n              경력사항\n            ")]), _vm._v(" "), _c('button', {
    staticClass: "tab-menu",
    class: {
      'is-active': _vm.selectedTab === 'qualifications'
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.changeTab('qualifications')
      }
    }
  }, [_vm._v("\n              자격증/면허증\n            ")]), _vm._v(" "), _c('button', {
    staticClass: "tab-menu",
    class: {
      'is-active': _vm.selectedTab === 'oaskills'
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.changeTab('oaskills')
      }
    }
  }, [_vm._v("\n              OA작성능력\n            ")]), _vm._v(" "), _c('button', {
    staticClass: "tab-menu",
    class: {
      'is-active': _vm.selectedTab === 'activities'
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.changeTab('activities')
      }
    }
  }, [_vm._v("\n              주요활동/사회공헌\n            ")]), _vm._v(" "), _c('button', {
    staticClass: "tab-menu",
    class: {
      'is-active': _vm.selectedTab === 'preferences'
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.changeTab('preferences')
      }
    }
  }, [_vm._v("\n              희망 활동(근무) 조건\n            ")]), _vm._v(" "), _c('button', {
    staticClass: "tab-menu",
    class: {
      'is-active': _vm.selectedTab === 'introduction'
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.changeTab('introduction')
      }
    }
  }, [_vm._v("\n              자기소개서\n            ")])])]), _vm._v("\n          [저장하기]버튼은 현재 활성화된 탭 메뉴의 내용만 저장됩니다."), _c('br'), _vm._v("\n          저장하지 않고 탭을 이동할 경우, 기존에 작성하신 내용이 유지되지 않으니 유의해주세요.\n        "), _c('div', {
    staticClass: "tab-content__wrap new-type"
  }, [_c('div', {
    staticClass: "tab-content",
    class: {
      'is-active': _vm.selectedTab === 'basic'
    }
  }, [_c('basic-modal', {
    ref: "basic",
    attrs: {
      "basicModal": _vm.modals['basic'],
      "resume": _vm.resume
    },
    on: {
      "update:CompletionRate": _vm.updateCompletionRate,
      "update:indbankNo": _vm.updateIndbankNo
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "tab-content",
    class: {
      'is-active': _vm.selectedTab === 'schools'
    }
  }, [_c('schools-modal', {
    ref: "schools",
    attrs: {
      "schoolsModal": _vm.modals['schools'],
      "indbankNo": _vm.resume.indbankNo,
      "educationLevels": _vm.codes.educationLevels,
      "graduationStatuses": _vm.codes.graduationStatuses,
      "schoolTypes": _vm.codes.schoolTypes
    },
    on: {
      "update:CompletionRate": _vm.updateCompletionRate
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "tab-content",
    class: {
      'is-active': _vm.selectedTab === 'careers'
    }
  }, [_c('careers-modal', {
    ref: "careers",
    attrs: {
      "careersModal": _vm.modals['careers'],
      "indbankNo": _vm.resume.indbankNo
    },
    on: {
      "update:CompletionRate": _vm.updateCompletionRate
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "tab-content",
    class: {
      'is-active': _vm.selectedTab === 'qualifications'
    }
  }, [_c('qualifications-modal', {
    ref: "qualifications",
    attrs: {
      "qualificationsModal": _vm.modals['qualifications'],
      "indbankNo": _vm.resume.indbankNo,
      "passingSteps": _vm.codes.passingSteps
    },
    on: {
      "update:CompletionRate": _vm.updateCompletionRate
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "tab-content",
    class: {
      'is-active': _vm.selectedTab === 'oaskills'
    }
  }, [_c('oaskills-modal', {
    ref: "oaskills",
    attrs: {
      "oaskillsModal": _vm.modals['oaskills'],
      "indbankNo": _vm.resume.indbankNo,
      "oaSkillsCode": _vm.codes.oaSkills
    },
    on: {
      "update:CompletionRate": _vm.updateCompletionRate
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "tab-content",
    class: {
      'is-active': _vm.selectedTab === 'activities'
    }
  }, [_c('activities-modal', {
    ref: "activities",
    attrs: {
      "activitiesModal": _vm.modals['activities'],
      "indbankNo": _vm.resume.indbankNo,
      "activitiesCodes": _vm.codes.activities
    },
    on: {
      "update:CompletionRate": _vm.updateCompletionRate
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "tab-content",
    class: {
      'is-active': _vm.selectedTab === 'preferences'
    }
  }, [_c('preferences-modal', {
    ref: "preferences",
    attrs: {
      "preferencesModal": _vm.modals['preferences'],
      "district": _vm.district,
      "indbankNo": _vm.resume.indbankNo,
      "codes": _vm.codes
    },
    on: {
      "update:CompletionRate": _vm.updateCompletionRate
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "tab-content",
    class: {
      'is-active': _vm.selectedTab === 'introduction'
    }
  }, [_c('introduction-modal', {
    ref: "introduction",
    attrs: {
      "introductionModal": _vm.modals['introduction'],
      "indbankNo": _vm.resume.indbankNo
    },
    on: {
      "update:CompletionRate": _vm.updateCompletionRate
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "box-type bg-primary mt-40"
  }, [_c('ul', {
    staticClass: "list-type-dot"
  }, [_c('li', [_vm._v("\n            ‘사업참여 이력’’ 및 ‘교육이수 이력’은 이력서에 자동으로 첨부됩니다.\n            "), _c('div', {
    staticClass: "butotn-area flex gap10 mt-8"
  }, [_c('button', {
    staticClass: "btn btn-line-box btn-sm",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.showJobActHistories
    }
  }, [_vm._v("사업참여이력")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-line-box btn-sm",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.showEducationHistories
    }
  }, [_vm._v("교육이수이력")])])])])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.modalState === 'education'),
      expression: "modalState === 'education'"
    }],
    key: "education-modal"
  }, [(_vm.modalState === 'education') ? _c('education-histories-modal', {
    ref: "educationHistoriesModal",
    attrs: {
      "educationHistoriesModal": true,
      "indbankNo": _vm.resume.indbankNo,
      "autoLoad": true
    },
    on: {
      "error": _vm.handleHistoryError
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.modalState === 'jobact'),
      expression: "modalState === 'jobact'"
    }],
    key: "jobact-modal"
  }, [(_vm.modalState === 'jobact') ? _c('job-act-histories-modal', {
    ref: "jobActHistoriesModal",
    attrs: {
      "jobActHistoriesModal": true,
      "indbankNo": _vm.resume.indbankNo,
      "autoLoad": true
    },
    on: {
      "error": _vm.handleHistoryError
    }
  }) : _vm._e()], 1)]), _vm._v(" "), (_vm.modalState === 'resume') ? _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-secondary btn-md button-wid150",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.close
    }
  }, [_vm._v("\n        취소하기\n      ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary btn-md button-wid150",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.save
    }
  }, [_vm._v("\n        저장하기\n      ")])]) : _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-secondary btn-md button-wid150",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.backToResumeModal
    }
  }, [_vm._v("\n        닫기\n      ")])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-close only-icon close-modal",
    attrs: {
      "type": "button",
      "aria-label": "닫기",
      "title": "닫기"
    },
    on: {
      "click": _vm.close
    }
  }, [_c('i', {
    staticClass: "ico ico-x-bl"
  })])])]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ed35b490"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/main/resume/Detail.vue
// module id = 1529
// module chunks = 6